import { useEffect, useState } from 'react';
import { fetchRenewals } from '../services/api';
import {Link} from 'react-router-dom';

function alertBadge(days: number | null) {
  if (days == null) return <span className="badge gray">–</span>;
  if (days <= 0) return <span className="badge red">Expiré</span>;
  if (days <= 30) return <span className="badge red">30 jours</span>;
  if (days <= 90) return <span className="badge orange">90 jours</span>;
  return <span className="badge blue">À venir</span>;
}

export default function RenewalsPage() {
  const [data, setData] = useState<any>(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRenewals()
      .then(setData)
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (error) return <div className="error-msg">{error}</div>;
  if (loading) return <div className="loading">Chargement...</div>;

  const summary = data?.summary || data?.kpis || {};
  const items = data?.items || data?.upcoming || (Array.isArray(data) ? data : []);

  return (
    <div className="card">
      <h3>Calendrier des renouvellements</h3>

      <div className="grid4" style={{ marginTop: 18 }}>
        <div className="kpi"><small>Dans 90 jours</small><strong>{summary.within_90d ?? items.filter((r: any) => r.days_remaining != null && r.days_remaining <= 90 && r.days_remaining > 0).length}</strong></div>
        <div className="kpi"><small>Dans 30 jours</small><strong>{summary.within_30d ?? items.filter((r: any) => r.days_remaining != null && r.days_remaining <= 30 && r.days_remaining > 0).length}</strong></div>
        <div className="kpi"><small>Expirées</small><strong>{summary.expired ?? items.filter((r: any) => r.days_remaining != null && r.days_remaining <= 0).length}</strong></div>
        <div className="kpi"><small>Montant à prévoir</small><strong>{['USD','CDF'].map(currency=>`${new Intl.NumberFormat('fr-FR',{minimumFractionDigits:2,maximumFractionDigits:2}).format(items.filter((r:any)=>r.currency===currency).reduce((total:number,r:any)=>total+Number(r.renewal_amount||0),0))} ${currency}`).join(' / ')}</strong></div>
      </div>

      <div className="table-wrap" style={{ marginTop: 18 }}>
        <table>
          <thead>
            <tr><th>Date</th><th>Établissement</th><th>Catégorie</th><th>Durée</th><th>Montant</th><th>Alerte</th><th>Action</th></tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={7} style={{ textAlign: 'center', color: 'var(--muted)' }}>Aucun renouvellement prévu</td></tr>}
            {items.map((r: any, i: number) => (
              <tr key={i}>
                <td>{r.expiry_date || r.renewal_date || r.date || '–'}</td>
                <td>{r.hotel_name || r.establishment_name || r.name || '–'}</td>
                <td>{r.category_code || r.category || '–'}</td>
                <td>{r.validity_months?`${r.validity_months} mois`:'–'}</td>
                <td>{r.renewal_amount == null?'–':`${r.renewal_amount} ${r.currency||'Devise à vérifier'}`}</td>
                <td>{alertBadge(r.days_remaining)}{r.renewal_status==='pending'&&<span className="badge orange">Demande en cours</span>}</td>
                <td>{r.license_id?<Link className="btn primary" to={`/licenses?license=${encodeURIComponent(r.license_id)}`}>{r.renewal_status==='pending'?'Suivre la demande':'Préparer'}</Link>:<span>Licence indisponible</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
